module.exports = __webpack_public_path__ + "static/media/3-oct13mar14.a25e1e04.pdf";